<template>
    <div>
        <div v-if="!fromNow">{{ val }}</div>
        <div v-if="fromNow">{{ fromNowVal }}</div>
    </div>
</template>
<script>
const pad = (n) => String(n).padStart(2, '0');
const relativeTimeFormat = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
const relativeTimeDivisions = [
    [60, 'seconds'],
    [60, 'minutes'],
    [24, 'hours'],
    [7, 'days'],
    [4.34524, 'weeks'],
    [12, 'months'],
    [Infinity, 'years'],
];

export default {
    props: {
        date: {
            type: Number,
        },
        fromNow: {
            type: Boolean,
            default: false,
        },
        dateOnly: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        val() {
            const d = this.getDate();
            const datePart = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
            if (this.dateOnly) {
                return datePart;
            }
            return `${datePart} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
        },
        fromNowVal() {
            let duration = (this.getDate().getTime() - Date.now()) / 1000;
            for (const [amount, unit] of relativeTimeDivisions) {
                if (Math.abs(duration) < amount) {
                    return relativeTimeFormat.format(Math.round(duration), unit);
                }
                duration /= amount;
            }
            return '';
        },
    },
    methods: {
        getDate() {
            // a hack to tell the difference between epoch seconds and milliseconds
            const asSeconds = new Date(this.date * 1000);
            if (!isNaN(asSeconds.getTime()) && asSeconds.getTime() < Date.now()) {
                return asSeconds;
            }
            return new Date(this.date);
        },
    },
};
</script>
